import { messageAlert } from '@/event/alert/messageAlert'
import { ref } from 'vue'

export const messageUpdateInformations = ref(messageAlert)
